<script setup>
import { computed } from 'vue';
import { cva } from 'class-variance-authority';

/** A round control on the player's dark surface; `active` lights it gold, `badge` adds a tiny label (×3, 30m). */
const props = defineProps({
  icon: { type: String, required: true },
  label: { type: String, required: true },
  size: { type: String, default: 'md' },
  active: { type: Boolean, default: false },
  badge: { type: String, default: null },
  disabled: { type: Boolean, default: false },
});

const button = cva(
  'relative inline-flex items-center justify-center rounded-full transition-all duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-deen-gold disabled:opacity-30 disabled:pointer-events-none',
  {
    variants: {
      size: { sm: 'w-9 h-9 text-lg', md: 'w-11 h-11 text-xl', lg: 'w-14 h-14 text-[1.7rem]' },
      active: { true: 'text-deen-gold bg-deen-gold/10', false: 'text-white/70 hover:text-white hover:bg-white/10' },
    },
  }
);

const classes = computed(() => button({ size: props.size, active: props.active }));
</script>

<template>
  <button type="button" :class="classes" :aria-label="label" :title="label" :aria-pressed="active || undefined" :disabled="disabled">
    <iconify-icon :icon="icon" aria-hidden="true" />
    <span
      v-if="badge"
      class="absolute -bottom-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-deen-gold text-deen-ink text-[10px] font-bold leading-[18px] text-center"
      aria-hidden="true"
    >{{ badge }}</span>
  </button>
</template>
